import React, {Component} from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import {StaticQuery, graphql} from "gatsby"
import {Link} from 'gatsby';
import {Helmet} from "react-helmet";
import MainLayout from '../layouts/MainLayout';
import Header from '../templates/Header/Header';
import ThreeBlocks from '../components/ThreeBlocks';
import BasicLayout from '../layouts/BasicLayout';
import {theme, brk} from '../styles/constants.js';
import FullWidthLayout from "../layouts/FullWidthLayout";
import WorthList from '../components/WorthList';
import styled from "styled-components";
import BlockPress from "../components/BlockPress";


const Description = styled.div`
  width : 55%;
  margin :auto;
  padding-top : 55px;
  text-align : justify;
  
  p{
    padding-top : 20px;
  }
   @media (min-width : ${brk.S}) and (max-width: ${brk.L}) {
    width : 80%;
  }
  @media (max-width: ${brk.S}) {
    margin:auto;
    padding-top : 35px;
    width : 100%;
  }
  
`;
const PressTitle = styled.h2`
    border-bottom : 1px solid black;
    padding-bottom: 40px;

    font-family: 'Cormorant', serif;
    width: 90%;
    margin: auto;
    text-align: center;
    padding-bottom: 10px;
    text-transform: uppercase;
    padding-top : 40px;
    font-size: 30px;

	@media (max-width: ${brk.S}) {
		font-size: 20px;
	}
  
`;
const PressArticle = styled.div`
    width : 100%;
    display : flex;
    flex-wrap : wrap;

    h2 {
        font-family: 'Times', serif;
        font-size : 24px;
        font-weight : 600;
        text-align : center;
    }
    h3, p{ 
        font-family: 'Raleway', sans-serif;
    }
    
    
    h3{
        margin-top : 30px;
        text-align : right;
        font-style : italic;
    }
    p{
        margin-top : 20px;
        text-align : justify;
    }
   
  
  
`;
const FlowerboxContainer = styled.div`
  display: block;
    width: 100%;
    height : auto;
    background : black;
    overflow : hidden;
	
    
    
    @media (min-width: ${brk.L}) {

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
      }
    
    @media (min-width : ${brk.S}) and (max-width: ${brk.L}) {

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
      }
    
    @media (max-width : ${brk.S}){
        min-height: 300px;
		background-position: left !important;

        img{
          width : 100% !important;
          height : auto !important;
          height  : auto;
          max-height : inherit;
        }
    }
  
`;



const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
	min-height: 300px;
	position: relative;
	display: flex;
	background-position : center !important;
	background-size: cover !important;
	background-attachment: fixed !important;
    justify-content : center;
    align-items : flex-end;


`;

const FlowerboxContent = styled.div`
    width: 60%;
	max-width: 500px;
	margin: auto;
	margin-top : 35px;
	background-color: rgba(0,0,0,0.65);
	padding :  0 30px;
	margin-bottom : 160px;
	justify-content : center;
	align-items:center;
	
	@media (max-width : ${brk.S}) {
       width: 90%;
    }
        
	& h2, & p{
        display: block;
        width: 100%;
        text-align: center;
    
        margin: auto;
        color: white;
    
        @media (max-width : ${brk.S}) {
            width: 80%;
        }
    }
        
	& h2{
        font-family : 'Cormorant',serif;
		font-size: 30px;
		font-weight : 700;

        padding-top: 40px;
        margin-top: 0;
        @media (max-width : ${brk.S}) {
            padding-top: 50px;
        }	
	}
	& p{
        font-size: 16px;
        font-weight: 400;
    }
    
    
    &>div.description{
        display : flex;
        flex-direction : column;
        padding-top : 30px;
        align-content : center;
        width : 100%;
    }
     
    &>div#buttonFlowerbox{
        color: white !important; 
        border-color: white !important;
    
        &:hover{
            border-color: rgba(0,0,0,0) !important;
        }
    }
    
    

`;


const ButtonUnderlineExternal = styled.div`
  width: fit-content !important;
  max-width: 325px;
  background: none;
  border: 2px solid black;
  padding: 10px 30px 10px 30px;
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  display: block;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  -webkit-transition:0.5s;
  position: relative;
  color: black;
  cursor: pointer;
  text-align: center;
  margin:auto;
  margin-top:30px !important;
  
  & a{
    margin : 0;
  }

  &:hover{
    border: 2px solid whitesmoke;
    color: black;
  }

  &:before{
    width: 100%;
    /*height:100%;*/
    z-index: 3;
    content:'';
    position: absolute;
    bottom:0;
    left:0;
    box-sizing: border-box;
    -webkit-transform: scale(0);
    transition: 0.9s;
    border-bottom: 2px solid #FD9D87;
    -webkit-transform-origin: 0% 100%;
  }

  &:hover::after{
    -webkit-transform: scale(1);
  }
  &:hover::before{
    -webkit-transform: scale(1);
  }
  
  @media (max-width : ${brk.XS}) {
      margin: auto;
    }
`;


const StyledLink = styled.div`
  width: auto;
  max-width: 325px;
  background-color: rgba(0,0,0,0.7);
  border: 2px solid white;
  padding: 10px 30px 10px 30px;
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  display: block;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  -webkit-transition:0.5s;
  position: relative;
  color: white;
  cursor: pointer;
  text-align: center;

  &:hover{
    border: 2px solid rgba(0,0,0,0);
    background-color: rgba(0,0,0,0);
  }

  &:before{
    width: 100%;
    /*height:100%;*/
    z-index: 3;
    content:'';
    position: absolute;
    bottom:0;
    left:0;
    box-sizing: border-box;
    -webkit-transform: scale(0);
    transition: 0.9s;
    border-bottom: 2px solid #FD9D87;
    -webkit-transform-origin: 0% 100%;
  }

  &:hover::after{
    -webkit-transform: scale(1);
  }
  &:hover::before{
    -webkit-transform: scale(1);
  }
`;


class Index extends Component {
    render() {
        const {
            data,
            content,
            flowerbox,
            worth,
            presse
        } = this.props;

        return (
            <MainLayout>
                <Helmet>
                    <meta name="description" content={content.edges[0].node.seoDescription}/>
                    <meta id="meta-keywords" name="keywords" content={content.edges[0].node.seoKeywords}/>

                </Helmet>
                <div>

                    <Header data={content.edges[0].node.slider}/>

                    <FullWidthLayout style={{backgroundColor: 'white', color: 'black', paddingBottom : '35px'}}>
                        <BasicLayout>
                            <Description className={'description'}
                                 dangerouslySetInnerHTML={{ __html: data.event.edges[0].node.description.childMarkdownRemark.html }}
                            />
                            <ButtonUnderlineExternal>
                                <a href={'https://www.google.com/maps/@48.8813821,2.2928409,3a,82.2y,56h,90t/data=!3m7!1e1!3m5!1sAF1QipO_0Dvz6V7CQe5Ksfc1-TuCOnzt5otgvwDutHgw!2e10!3e12!7i13312!8i6656'} target={'_blank'}>
                                    Découvrir la MAISON DELANGLE à 360°
                                </a>
                            </ButtonUnderlineExternal>
                        </BasicLayout>
                    </FullWidthLayout>
                    <FullWidthLayout>
                        <ThreeBlocks content={content.edges[0].node.contentList}></ThreeBlocks>

                    </FullWidthLayout>
                    <FullWidthLayout>
                        <FlowerboxContainer>
                            <BackgroundImage  style={{ backgroundImage: `url(${flowerbox.images[0].fluid.src})`}}
                            >
                                <FlowerboxContent>
                                    <h2>{ flowerbox.title }</h2>
                                    <div className={'description'} dangerouslySetInnerHTML={{ __html: flowerbox.textContent.childMarkdownRemark.html }}/>

                                    <StyledLink>
                                        <Link className={'btn_underline'} to={flowerbox.buttonLink} >
                                            {flowerbox.buttonLabel}
                                        </Link>
                                    </StyledLink>
                                </FlowerboxContent>
                            </BackgroundImage>
                        </FlowerboxContainer>

                    </FullWidthLayout>
                    <FullWidthLayout>
                        <BasicLayout>
                            <WorthList worth={worth} />
                        </BasicLayout>
                    </FullWidthLayout>
                    <FullWidthLayout>
                        <BasicLayout>
                            <PressTitle> { presse.edges[0].node.name } </PressTitle>
                            <PressArticle>
                                <BlockPress block={ presse.edges[0].node.contentList[0]} key={'1'}/>
                                <BlockPress block={presse.edges[0].node.contentList[1] } key={'2'}/>
                            </PressArticle>
                        </BasicLayout>
                    </FullWidthLayout>
                </div>
            </MainLayout>
        )
    }
}

export default () => (
    <StaticQuery
        query={graphql`
          query indexQuery {
             event : allContentfulWebsite(filter: {
                slug : { eq : "fleurdelangle"}

                }) {
                  edges {
                     node {
                        id,
                        node_locale,
                        slug,
                        name,
                        logo {
                          id,
                          file {
                            url,
                            fileName,
                            contentType,
                          },
                          fluid(maxWidth: 1200) {
                             sizes,
                             src
                             srcSet
                             srcWebp
                             srcSetWebp

                          }

                        },
                        description {
                          id,
                          childMarkdownRemark{
                            html

                          }
                        }
                    }
                  }
                }
                content: allContentfulPage(filter: {name: {eq: "Accueil"}}) {
                    edges {
                      node {
                        id
                        slug
                        name
                        seoDescription
                        seoKeywords
                        header {
                          id
                          file {
                            url
                            fileName
                            contentType
                          }
                          fluid(maxWidth: 2000) {
                            src
                            srcSet
                            srcWebp
                            sizes
                          }
                        }
                        contentList {
                          ... on ContentfulContentBlock {
                            slug
                            title
                            subtitle
                            buttonLabel
                            buttonLink
                            images {
                              id
                              file {
                                url
                                fileName
                                contentType
                              }
                              fluid(maxWidth: 800) {
                                sizes
                                src
                                srcSet
                                srcWebp
                                srcSetWebp
                              }
                            }
                            textContent {
                              id
                              childMarkdownRemark {
                                html
                              }
                            }
                          }
                        }
                        slider {
                          id
                          file {
                            url
                            fileName
                            contentType
                          }
                          fluid(maxWidth: 2000) {
                            src
                            srcSet
                            srcWebp
                            sizes
                          }
                        }
                      }
                    }
                  }
              flowerbox: contentfulContentBlock(slug: {eq: "actualitesboxHome"}) {
                slug
                title
                subtitle
                buttonLabel
                buttonLink
                images {
                  id
                  file {
                    url
                    fileName
                    contentType
                  }
                  fluid(maxWidth: 2000) {
                    sizes
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                  }
                }
                textContent {
                  id
                  childMarkdownRemark {
                    html
                  }
                }
              }
              worth: allContentfulSpecificNeeds {
                edges {
                  node {
                    id
                    worths {
                      ... on ContentfulWorth {
                        slug
                        title
                        subtitle
                        buttonLabel
                        buttonLink
                        images {
                          id
                          file {
                            url
                            fileName
                            contentType
                          }
                          fluid(maxWidth: 800) {
                            sizes
                            src
                            srcSet
                            srcWebp
                            srcSetWebp
                          }
                        }
                        textContent {
                          id
                          childMarkdownRemark {
                            html
                          }
                        }
                      }
                    }
                  }
                }
              }
              presse : allContentfulPage(filter: {slug: {eq: "press"}}) {
                edges {
                  node {
                    id
                    slug
                    name
                    contentList {
                        ... on ContentfulPresse {
                        slug
                        title
                        author
                        articleContent {
                          id
                          childMarkdownRemark {
                            html
                          }
                        }
                      }
                    }
                  }
                }
              }
          }
        `}
        render={data => (
            <Index data={data} content={data.content} flowerbox={data.flowerbox} worth={data.worth} presse={data.presse}/>
        )}
    />
)
